<h2 mat-dialog-title>{{ labels.CREATE_PATIENT }}</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="createPatientForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" class="custom-form-field mt-4">
      <mat-label>{{ labels.PATIENT_NAME }}</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.PATIENT_BIRTHDAY }}</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="birthday" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.PATIENT_GENDER }}</mat-label>
      <mat-select formControlName="gender">
        <mat-option value="M">{{ labels.GENDER_M }}</mat-option>
        <mat-option value="F">{{ labels.GENDER_F }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.PATIENT_PHONE }}</mat-label>
      <input matInput formControlName="phoneNumber" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.PATIENT_EMAIL }}</mat-label>
      <input matInput formControlName="email" type="email" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.PATIENT_ADDRESS }}</mat-label>
      <textarea matInput formControlName="address" rows="3"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="custom-dialog-actions">
  <button mat-button mat-dialog-close class="custom-button">
    {{ labels.CANCEL }}
  </button>
  <button
    mat-button
    (click)="onSubmit()"
    [disabled]="!createPatientForm.valid"
    cdkFocusInitial
    class="custom-button"
  >
    {{ labels.CREATE_PATIENT }}
  </button>
</mat-dialog-actions>
